import React from 'react';
import cn from 'classnames';

import { DynamicIconWrapper, Icons } from '@components/common';

import styles from './DragHandle.module.scss';

interface IDragHandleProps {
	id: string;
	disabled?: boolean;
	isDragging?: boolean;

	[key: string]: any;
}

const DragHandle: React.FC<IDragHandleProps> = ({
	id,
	disabled = false,
	isDragging = false,
	...dragProps
}) => {
	const handleClassNames = cn(styles.dragHandle, {
		[styles.dragging]: isDragging,
		[styles.disabled]: disabled,
	});

	return (
		<div
			className={handleClassNames}
			{...dragProps}
		>
			<DynamicIconWrapper
				icon={Icons.dragHandle}
				isDisabled={disabled}
			/>
		</div>
	);
};

export default DragHandle;
